import axios from 'axios';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { notificationContainer } from 'utils/notificationContainer';
import {
	TGetNewMessageCountResponsePayload,
	TMarkAsReadMessageRequest,
	TDeleteMessageRequest,
	TMessagesResponsePayload,
	TOrganizationsResponsePayload,
	TUserInfoResponsePayload,
	THubspotVisitorTokenResponsePayload,
} from './types';

import {
	getMessagesRequest,
	getMessagesSuccess,
	getNewMessageCountRequest,
	getNewMessageCountSuccess,
	markAsReadMessageRequest,
	markAsReadMessageSuccess,
	deleteMessageRequest,
	deleteMessageSuccess,
	getOrganizationsRequest,
	getOrganizationsSuccess,
	getUserInfoRequest,
	getUserInfoSuccess,
	getHubspotVisitorTokenRequest,
	getHubspotVisitorTokenSuccess,
} from './reducer';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';
import { getAuth, getAuthRefreshToken, getRefreshTokenLoader } from '../auth/selectors';
import { refreshTokenByTimeOutWorker } from '../auth/saga';

function* getOrganizationsWorker() {
	try {
		// console.log('getOrganizationsWorker started');
		// yield put(refreshTokenByTimeOutRequest());
		// console.log('refreshTokenByTimeOutRequest dispatched for organizations');
		// yield take(refreshTokenByTimeOutSuccess.type);
		// console.log('refreshTokenByTimeOutSuccess received for organizations');

		const response: TOrganizationsResponsePayload = yield call(api.user.getOrganizations);
		// console.log('getOrganizations API response:', response);
		yield put(getOrganizationsSuccess(response));
	} catch (error) {
		// console.error('getOrganizationsWorker error:', error);
		if (axios.isAxiosError(error)) {
			// console.error('Axios error details for organizations:', error.response?.data);
			// notificationContainer(String(error), 'error');
		}
		// yield put(userInitState());
	}
}

function* getUserInfoRequestWorker() {
	try {
		// console.log('getUserInfoRequestWorker started');
		yield put(refreshTokenByTimeOutRequest());
		// console.log('refreshTokenByTimeOutRequest dispatched');
		yield take(refreshTokenByTimeOutSuccess.type);
		// console.log('refreshTokenByTimeOutSuccess received');

		const response: TUserInfoResponsePayload = yield call(api.user.getUserInfo);
		// console.log('getUserInfo API response:', response);
		yield put(getUserInfoSuccess(response));
	} catch (error) {
		// console.error('getUserInfoRequestWorker error:', error);
		if (axios.isAxiosError(error)) {
			// console.error('Axios error details:', error.response?.data);
			// notificationContainer(String(error), 'error');
		}
		// yield put(userInitState());
	} finally {
		// yield put(hideLoading());
	}
}

function* getNewMessageCountRequestWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TGetNewMessageCountResponsePayload = yield call(api.user.getNewMessageCount);

		yield put(getNewMessageCountSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

function* getMessagesRequestWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TMessagesResponsePayload = yield call(api.user.getMessages);
		yield put(getMessagesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(userInitState());
	} finally {
		// yield put(hideLoading());
	}
}

function* markAsReadMessageRequestWorker(action: PayloadAction<TMarkAsReadMessageRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.user.markAsReadMessage, payload);
		yield put(markAsReadMessageSuccess());
		yield put(getMessagesRequest());
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(userInitState());
	} finally {
		// yield put(hideLoading());
	}
}

function* deleteMessageRequestWorker(action: PayloadAction<TDeleteMessageRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.user.deleteMessage, payload);
		yield put(deleteMessageSuccess());
		yield put(getMessagesRequest());
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(userInitState());
	} finally {
		// yield put(hideLoading());
	}
}

function* getHubspotVisitorTokenRequestWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: THubspotVisitorTokenResponsePayload = yield call(
			api.user.getHubspotVisitorToken,
		);
		yield put(getHubspotVisitorTokenSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(userInitState());
	}
}

export function* userSaga() {
	yield takeEvery(getOrganizationsRequest.type, getOrganizationsWorker);
	yield takeEvery(getUserInfoRequest.type, getUserInfoRequestWorker);
	yield takeEvery(getNewMessageCountRequest.type, getNewMessageCountRequestWorker);
	yield takeEvery(getMessagesRequest.type, getMessagesRequestWorker);
	yield takeEvery(markAsReadMessageRequest.type, markAsReadMessageRequestWorker);
	yield takeEvery(deleteMessageRequest.type, deleteMessageRequestWorker);
	yield takeEvery(getHubspotVisitorTokenRequest.type, getHubspotVisitorTokenRequestWorker);
}
